import { render, staticRenderFns } from "./DonutChart29.vue?vue&type=template&id=ec56d62a&scoped=true"
import script from "./DonutChart29.vue?vue&type=script&lang=js"
export * from "./DonutChart29.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec56d62a",
  null
  
)

export default component.exports